import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Type,
  ViewChild
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {Subscription} from 'rxjs';
import {ImageUploadData} from 'src/app/entities/ImageUploadData.entity';

@Component({
  selector: 'app-form-image-upload',
  templateUrl: './form-image-upload.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FormImageUploadComponent {
  @Input() public label!: string;
  @Input() public control!: UntypedFormControl;
  @Input() public name!: string;
  @Input() public required = false;
  @Input() public requiredRatioWidth: number = 0;
  @Input() public requiredRatioHeight: number = 0;
  @Output('fileChanged') public fileChanged: EventEmitter<ImageUploadData> = new EventEmitter<ImageUploadData>();

  private fileReader?: FileReader;
  private img?: HTMLImageElement;
  private formData?: FormData;
  private ratioCheckEnabled: boolean = false;

  public ngOnInit() {
    this.ratioCheckEnabled = (this.requiredRatioWidth !== 0) && (this.requiredRatioWidth !== 0);
    let dataUrl = null;
    this.fileReader = new FileReader();
    this.fileReader.onload = () => {
      this.img = new Image();
      this.img.onload = () => {
        if(this.ratioCheckEnabled) {
          const precision = 1 / (Math.max(this.img!.width, this.img!.height) + 1);
          if( !(Math.abs(this.requiredRatioWidth / this.requiredRatioHeight - this.img!.width / this.img!.height) > precision) ) {
            this.fileChanged.next({
              'formData': this.formData!,
              'dataUrl': null,
            });
          } else {
            this.control.setErrors(
              {
                serverError: 'Image with invalid ratio given. Following image ratio is required: ' + this.requiredRatioWidth + ' / ' + this.requiredRatioHeight,
              },
              { emitEvent: true },
            );
            this.cdr.markForCheck();
          }
        } else {
          this.fileChanged.next({
            'formData': this.formData!,
            'dataUrl': null,
          });
        }

      };
      if (typeof this.fileReader!.result === "string") {
        this.img.src = this.fileReader!.result;
      }
    };

  }

  public ngOnDestroy() {
    if(this.fileReader) {
      this.fileReader.abort();
      this.fileReader = undefined;
    }
    if(this.img) {
      this.img = undefined;
    }
  }

  public fileUploadChanged(event: any) {
    if(event.target.files && event.target.files[0] && event.target.files[0].type) {
      if(
        event.target.files[0].type.includes('image/jpeg') ||
        event.target.files[0].type.includes('image/png') ||
        event.target.files[0].type.includes('image/gif')
      ) {
        const file: File = event.target.files[0];
        const formData: FormData = new FormData();
        formData.append('image', file);

        this.formData = formData;

        this.fileReader!.readAsDataURL(event.target.files[0]);
      } else {
        this.control.setErrors(
          {
            serverError: 'Invalid file type selected, only PNG, JPEG, GIF and WEBP are allowed.',
          },
          { emitEvent: true },
        );
        this.cdr.markForCheck();
      }
    }
  }

  constructor(private cdr: ChangeDetectorRef) {}
}
